import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth/auth.service";

@Component({
  selector: "app-generator",
  templateUrl: "./generator.component.html",
  styleUrls: ["./generator.component.scss"],
  standalone: false,
})
export class GeneratorComponent implements OnInit {
  constructor(private auth: AuthService) {}

  ngOnInit() {
    const appUser = this.auth.appUser;
    if (appUser) {
      this.auth.getGeneratorToken(appUser).subscribe(
        (token) => {
          window.location.href = `https://generator.gsignature.com/?token=${token}`;
        },
        (error) => {
          console.error("Error generating token:", error);
        },
      );
    } else {
      console.error("appUser not available");
    }
  }
}
